import {inject, Injectable} from '@angular/core';
import {firstValueFrom, Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {Token, Datalogin} from '@kilobytelab/types';
import {API_URL_TOKEN} from '../token';

@Injectable({
  providedIn: 'root'
})
export class ApiLoginService {

  private http = inject(HttpClient);
  private apiUrl = inject(API_URL_TOKEN);

  /*** OPEN ***/
  /*** login ***/

  checkLogin(data: Datalogin): Promise<Datalogin> {
    const url = `${this.apiUrl}login/checkEmail`;
    return firstValueFrom(this.http.post<Datalogin>(url, data))
  }
  login(data: Datalogin): Promise<Token> {
    const url = `${this.apiUrl}login/trusted`;
    return firstValueFrom(this.http.post<Token>(url, data))
  }
  checkCode(data: Datalogin): Promise<Token> {
    const url = `${this.apiUrl}login/code`;
    return firstValueFrom(this.http.post<Token>(url, data))
  }
  refreshToken(): Observable<void> {
    const url = `${this.apiUrl}login/refresh`;
    return this.http.get<void>(url)
  }
  logout(): Promise<any> {
    const url = `${this.apiUrl}login/logout`;
    return firstValueFrom(this.http.get<any>(url))
  }
  /*** version ***/
  getVersion(type: string): Promise<string> {
    const url = `${this.apiUrl}version/${type}`;
    return firstValueFrom(this.http.get<string>(url))
  }

  /*** PRIVATE ***/
  changeBBDD(bbdd: string): Promise<Token> {
    const url = `${this.apiUrl}login/change/${bbdd}`;
    return firstValueFrom(this.http.get<Token>(url))
  }
}
